<template>
  <div class="content" v-loading="loading">
    <div class="transaction-details">
      <div class="header">
        <h1>Transaction Details</h1>
        <div class="search-box">
          <el-input
            placeholder="Search accounts, transactions"
            v-model="searchQuery"
            class="input-box"
            @keyup.enter.native="claimToken"
          />
          <div
            class="claim-button"
            :class="{ 'claim-button-active': searchQuery }"
            @click="claimToken"
          >
            <img src="../assets/icon_search_28@2x.png" alt="" />
          </div>
        </div>
      </div>

      <div class="info-box">
        <div class="title">Overview</div>
        <div class="info-details-box">
          <div class="item-box">
            <div class="label">TX Hash</div>
            <div class="details">
              <span>{{ txHash }}</span>
              <el-tooltip
                popper-class="copyTips"
                content="Copy to clipboard"
                placement="top"
                effect="light"
                :visible-arrow="false"
              >
                <img
                  @click="copyToClipboard(txHash)"
                  class="copy"
                  src="../assets/icon_copy_20@2x.png"
                  alt=""
                />
              </el-tooltip>
            </div>
          </div>
          <div class="item-box">
            <div class="label">Block</div>
            <div class="details">
              <span>{{ block }}</span>
              <el-tooltip
                popper-class="copyTips"
                content="Copy to clipboard"
                placement="top"
                effect="light"
                :visible-arrow="false"
              >
                <img
                  @click="copyToClipboard('#0000000000')"
                  class="copy"
                  src="../assets/icon_copy_20@2x.png"
                  alt=""
                />
              </el-tooltip>
            </div>
          </div>
          <div class="item-box">
            <div class="label">Timestamp</div>
            <div class="details">
              {{ Timestamp }}
            </div>
          </div>
          <div class="item-box">
            <div class="label">Result</div>
            <div class="details" :class="state == 0 ? 'green' : 'red'">
              <img
                class="stateImg"
                :src="
                  state == 0
                    ? require('../assets/icon_hint_Success_20@2x.png')
                    : require('../assets/icon_hint_fail_20@2x.png')
                "
                alt=""
              />
              <span>{{ state == 0 ? "Success" : "Failed" }}</span>
            </div>
          </div>
          <div class="item-box">
            <div class="label">Sender</div>
            <div class="details green jump">
              <span @click="jumpAccount(sender)">{{ sender }}</span>
              <el-tooltip
                popper-class="copyTips"
                content="Copy to clipboard"
                placement="top"
                effect="light"
                :visible-arrow="false"
              >
                <img
                  @click="copyToClipboard(sender)"
                  class="copy"
                  src="../assets/icon_copy_20@2x.png"
                  alt=""
                />
              </el-tooltip>
            </div>
          </div>
          <div class="item-box">
            <div class="label">Receiver</div>
            <div class="details green jump">
              <span @click="jumpAccount(receiver)">{{ receiver }}</span>
              <el-tooltip
                popper-class="copyTips"
                content="Copy to clipboard"
                placement="top"
                effect="light"
                :visible-arrow="false"
              >
                <img
                  @click="copyToClipboard(receiver)"
                  class="copy"
                  src="../assets/icon_copy_20@2x.png"
                  alt=""
                />
              </el-tooltip>
            </div>
          </div>
          <div class="item-box">
            <div class="label">Amount</div>
            <div class="details">{{ formatNumber1(amount) }} CNHO</div>
          </div>
          <div class="item-box">
            <div class="label">Fee</div>
            <div class="details">{{ formatNumber1(fee) }} CNHO</div>
          </div>
          <div class="item-box">
            <div class="label">Operation</div>
            <div class="details">Transfer</div>
          </div>
          <div class="item-box">
            <div class="label">Gas Limits</div>
            <div class="details">{{ addThousandSeparators(gasLimit) }}</div>
          </div>
          <div class="item-box">
            <div class="label">Gas Used</div>
            <div class="details">{{ addThousandSeparators(gasUsed) }}</div>
          </div>
          <div class="item-box">
            <div class="label">Gas Price</div>
            <div class="details">{{ gasPrice }} Gwei</div>
          </div>
          <div class="item-box" style="margin-bottom: 0">
            <div class="label">Sequence</div>
            <div class="details">{{ sequence }}</div>
          </div>
        </div>
      </div>

      <div class="message-box">
        <div
          class="title"
          :style="showDetails ? 'margin-bottom:20px' : 'margin-bottom:0'"
        >
          <span>Message</span>
          <div class="hideButton" @click="toggleDetails">
            {{ messageButton }}
            <img
              :src="
                showDetails
                  ? require('../assets/icon_down_28@2x.png')
                  : require('../assets/icon_unfold_28@2x.png')
              "
              alt=""
            />
          </div>
        </div>
        <div v-if="showDetails" class="message-detail-box">
          <p>@Type /cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward</p>
          <pre>{{ message }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      searchQuery: "",
      state: "",
      txHash: "",
      Timestamp: "",
      gasUsed: "",
      amount: "",
      gasLimit: "",
      fee: "",
      block: "",
      sequence: "",
      sender: "",
      receiver: "",
      gasPrice: "",
      showDetails: false,
      message: "",
      messageButton: "View more details",
    };
  },
  created() {
    this.txHash = this.$route.params.id;
    this.txsHash();
  },
  methods: {
    formatGwei(fee, gasLimit) {
      // 将 fee 转换为 Gwei
      const gwei = (fee * 1e6) / gasLimit;

      // 乘以 10^6 并向上取整，然后再除以 10^6
      const multiplier = 1e6;
      const roundedValue = Math.ceil(gwei * multiplier) / multiplier;

      // 将结果转换为字符串
      let [integerPart, decimalPart] = roundedValue.toFixed(6).split(".");

      // 添加千位分隔符
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // 移除多余的 0
      decimalPart = decimalPart ? decimalPart.replace(/0+$/, "") : "";

      // 合并整数部分和小数部分
      return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
    },
    addThousandSeparators(num) {
      // 将数字转换为字符串
      let numStr = num.toString();
      // 使用正则表达式添加千位分隔符
      return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    jumpAccount(account) {
      const url = this.$router.resolve({
        name: "Account",
        params: { id: account },
      }).href;
      window.open(url, "_blank");
    },
    divideAndFormat(number) {
      const result = number / 1000000;
      return result.toFixed(6);
    },
    formatDate(isoDateStr) {
      // 将 ISO 日期字符串转换为 Date 对象
      const date = new Date(isoDateStr);

      // 获取日期的各个部分，并转换为本地时区的时间
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "Asia/Shanghai",
        timeZoneName: "short",
      };

      // 使用 Intl.DateTimeFormat 格式化日期
      const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
        date
      );

      return formattedDate;
    },
    formatNumber1(num) {
      // 向上取整并保留小数点后7位
      let roundedNum = Math.ceil(num * 1e7) / 1e7;
      // 转换为字符串并移除末尾的0
      let [integerPart, decimalPart] = roundedNum
        .toFixed(6)
        .replace(/\.?0+$/, "")
        .split(".");
      // 添加千位分隔符
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // 合并整数部分和小数部分
      return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
    },
    formatNumber(value) {
      // 乘以 10^6 并向上取整，然后再除以 10^6
      const multiplier = 1e6;
      const roundedValue = Math.ceil(value * multiplier) / multiplier;

      // 将结果转换为字符串
      let [integerPart, decimalPart] = roundedValue.toFixed(6).split(".");

      // 添加千位分隔符
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // 移除多余的 0
      decimalPart = decimalPart ? decimalPart.replace(/0+$/, "") : "";

      // 合并整数部分和小数部分
      return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
    },

    txsHash() {
      let params = {
        hash: this.txHash,
      };
      this.$api.txsHash(params).then((response) => {
        this.loading = false;
        this.buttonText = "Claim";
        this.Timestamp =
          this.formatDate(response.data.tx_response.timestamp) || 0;
        this.gasUsed = response.data.tx_response.gas_used || 0;
        this.message = response.data.tx_response || "";
        this.amount = this.divideAndFormat(
          response.data.tx_response.tx.body.messages[0].amount.length > 0
            ? response.data.tx_response.tx.body.messages[0].amount[0].amount
            : response.data.tx_response.tx.body.messages[0].amount.amount
        );
        this.gasLimit =
          response.data.tx_response.tx.auth_info.fee.gas_limit || 0;
        this.fee =
          this.divideAndFormat(
            response.data.tx_response.tx.auth_info.fee.amount[0].amount
          ) || 0;
        this.block = response.data.tx_response.height || 0;
        this.state = response.data.tx_response.code || 0;
        this.sequence =
          response.data.tx.auth_info.signer_infos[0].sequence || 0;
        // this.sender =
        //   response.data.tx_response.tx.body.messages[0].from_address||0;
        // this.receiver =
        //   response.data.tx_response.tx.body.messages[0].to_address||0;
        this.gasPrice =
          this.formatGwei(
            response.data.tx_response.tx.auth_info.fee.amount[0].amount,
            this.gasLimit
          ) || 0;
        // if(!response.data.error){
        // }else{
        //   this.$message.error(response.data.error)
        // }
        // this.data = response.data;
        if (response.data.tx_response.logs.length > 0) {
          response.data.tx_response.logs[0].events.map((item) => {
            if (item.type == "coin_received") {
              this.receiver = item.attributes[0].value;
            } else if (item.type == "coin_spent") {
              this.sender = item.attributes[0].value;
            }
          });
        }else{
          this.sender =
          response.data.tx_response.tx.body.messages[0].from_address||0;
        this.receiver =
          response.data.tx_response.tx.body.messages[0].to_address||0;
        }
      });
    },
    getAccounts2() {
      this.$api
        .getAccounts(this.searchQuery)
        .then((response) => {
          let id = this.searchQuery;
          this.$router.push({ name: "Account", params: { id } });
        })
        .catch((error) => {
          if (error) this.txsHash2(this.searchQuery);
        });
    },
    txsHash2(id) {
      let params = {
        hash: id,
      };
      this.$api
        .txsHash(params)
        .then((response) => {
          let id = this.searchQuery;
          this.$router.push({ name: "Transaction", params: { id } });
          window.location.reload();
        })
        .catch((error) => {
          // this.$router.push({ name: "Nothing", params: { id } });
          if (id.startsWith("chno")) {
            this.$router.push({ name: "Nothing", params: { id } });
          } else {
            this.$router.push({ name: "TxNothing", params: { id } });
          }
        });
    },
    claimToken() {
      if (!this.searchQuery) return;
      let id = this.searchQuery;
      if (this.getAccounts2()) {
        this.$router.push({ name: "Account", params: { id } });
      }
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success("Copied to clipboard");
      });
    },
    toggleDetails() {
      this.showDetails = !this.showDetails;
      if (this.showDetails) {
        this.messageButton = "Hide details";
      } else {
        this.messageButton = "View more details";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  h1 {
    font-size: 35px;
    font-weight: 900;
    color: #000;
  }
  .search-box {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 2px;
    width: 560px;
  }
  .claim-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #cbe6de;
    color: #fff;
    border-radius: 5px;
    width: 76px;
    height: 38px;
    cursor: pointer;
    img {
      width: 30px;
    }
  }
  .claim-button-active {
    background-color: #018761 !important;
  }
}

.search-input {
  max-width: 300px;
}
.content {
  display: flex;
  justify-content: center;
  .transaction-details {
    width: 1400px;
    max-width: 1400px;
  }
}
.message-box {
  background: #fff;
  border-radius: 12px;
  padding: 24px 12px;
  margin-top: 12px;
  margin-bottom: 60px;
  .hideButton {
    color: #018761;
    font-size: 15px;
    margin-left: 36px;
    font-weight: 600;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: 4px;
    img {
      width: 24px;
      margin-left: 6px;
    }
  }
  .title {
    font-weight: 900;
    text-align: left;
    display: flex;
    align-items: center;
    span {
      font-size: 20px;
    }
  }
  .message-detail-box {
    background: #f2f2f2;
    border-radius: 8px;
    padding: 24px 16px;
    text-align: left;
    line-height: 22px;
    pre {
      white-space: pre-wrap;
    }
  }
}
.info-box {
  background: #fff;
  border-radius: 12px;
  padding: 24px 12px;
  .title {
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 900;
    text-align: left;
  }
  .info-details-box {
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 24px 16px;
    .jump {
      cursor: pointer;
    }
    .green {
      color: #028760 !important;
    }
    .red {
      color: #ba2636;
    }
    .item-box {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      text-align: left;
      .label {
        width: 120px;
        font-weight: 600;
        margin-right: 36px;
      }
      .details {
        display: flex;
        align-items: center;
        color: #2c3e50b1;
        .stateImg {
          width: 20px;
          margin-right: 6px;
        }
        .copy {
          width: 20px;
          margin-left: 6px;
          cursor: pointer;
        }
      }
    }
  }
}

.box-card {
  margin-bottom: 20px;
}

.success {
  color: green;
}

.copyable {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}
</style>
